/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ClassType {
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
  WAGE_TYPE = 'WAGE_TYPE',
  NONE = 'NONE',
}
